export default (routes, path) => {
  return routes.find((route) => route.path === path);
};
